import React from 'react';
import { Loader } from '@naf/loader';
import { SpinnerWrapper } from './Styles';

export const Spinner = () => (
  <SpinnerWrapper>
    <Loader />
  </SpinnerWrapper>
);
